import { useEffect } from 'react';
import Loading from '../../components/loading';
import request from '../../lib/request';

const PaypalApprove = () => {
  useEffect(() => {
    approveSubscription();
  }, []);

  const approveSubscription = async () => {
    try {
      const { result } = await request.post('/paypal/approve', {});
      window.location.href = '/success';
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <div className='flex items-center justify-center min-h-dvh bg-primary'>
      <div className='flex flex-col items-center space-y-4'>
        <Loading />
        <div className={`text-lg font-medium text-white`}>Loading...</div>
      </div>
    </div>
  );
};

export default PaypalApprove;
